// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes shake{
  0%,
  100%{
    transform:translateX(0);
  }
  20%,
  60%{
    transform:translateX(-0.375rem);
  }
  40%,
  80%{
    transform:translateX(0.375rem);
  }
}
:root{
  --select-border:1px solid var(--colorGrey20);
}
.button.submit{
    position:relative;
  }
.button.submit .submit__loader{
      position:absolute;
      right:0;
      bottom:0;
      left:0;
    }
.button.submit.button--submitting{
      z-index:100;
    }
.button--submitting.button--forward::after,
    .button--submitting.button--backward::before,
    .button--submitting.button:disabled.button--forward::after,
    .button--submitting.button:disabled.button--backward::before{
      display:none;
    }
.button--error{
    animation:shake 0.4s;
  }
.button--error.button--forward::after,
    .button--error.button--backward::before{
      display:none;
    }
.button-group > .button{
    margin-right:1rem;
  }
.button-toggle{
  padding:0.25rem;
  line-height:1rem;
  cursor:pointer;
  border:0;
  border-radius:50%;

  color:#707070;

  background-color:transparent;
}
.button-toggle:hover{
    color:#707070;
    background-color:#f6f7f8;
  }
.button-toggle:active{
    color:#1a1a1a;
    background-color:#f6f7f8;
  }
.button-toggle.toggle-button--enabled{
    color:#206dd2;
  }
.button-toggle.toggle-button--enabled:active{
      color:#00429d;
    }
.modal--disable-animation{
    animation:none;
  }
@media (width > 640px){
.modal__body--fixed-height{
      height:80vh;
      max-height:80vh
  }
    }
.modal__body--show-loader{
    position:relative;
    visibility:hidden;
  }
.modal__body--show-loader button{
      transition:none;
    }
.modal__body--show-loader .modal__loader{
      visibility:visible;
    }
.modal__button-icon{
    margin-left:0.25rem;
  }
.modal__buttons{
    display:flex;
    gap:1rem;
    justify-content:flex-end;
    margin-top:1rem;
  }
@media (width <= 640px){
.modal__buttons{
      flex-direction:column-reverse;
      flex-wrap:wrap
  }
      .modal__buttons button{
        flex:1 1 50%;
      }
    }
.modal__buttons--full-width button{
        flex:1 1 50%;
      }
.modal__close{
    position:absolute;
    top:1.5rem;
    right:1.25rem;
  }
@media (width > 640px){
.modal__content{
      max-height:80vh
  }
      .modal__content--fixed-height{
        height:80vh;
      }

      .modal__content--large{
        max-width:min(35.875rem, 95vw);
      }

      .modal__content--extra-large{
        max-width:min(84.313rem, 95vw);
      }

      .modal__content--medium{
        max-width:min(25.875rem, 95vw);
      }

      .modal__content--fullscreen{
        max-width:95vw;
        height:100%;
      }

      .modal__content--fullscreen-overlay{
        top:unset;
        left:unset;
        width:100%;
        max-width:none;
        height:100%;
        max-height:100%;
        border-radius:unset;
        box-shadow:unset;
        transform:unset;
      }
    }
.modal__content--no-scroll{
      overflow-y:hidden;
    }
.modal__header{
    display:flex;
    flex-direction:row;
    gap:0.5rem;
    padding:1.5rem;
    margin-bottom:0.5rem;
    border-bottom:1px solid #e5e6e6;
  }
.modal__header--no-close-button{
      padding-right:0;
    }
.modal__loader{
    position:absolute;
    top:50%;
    left:50%;
    visibility:hidden;
    width:3rem;
    height:3rem;
    transform:translate(-50%, -50%);
  }
.modal__title{
    margin:0;
    line-height:1.5rem;
  }
.modal .outside-clickbox{
    position:absolute;
    inset:0;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
